<template>
  <div>
    <FormulateInput
      v-if="personalizedType !== 'clipartCategory'"
      :name="layer.id"
      :label="label"
      :shapes="shapeDefauld"
      :typeskystar="layer.typeSkyStar"
      type="imagestarmap"
      :skystaridparent="layer.skyStarIdParent"
      :transparentbackground='layer.transparentbackground'
      :aspectRatio="aspectRatio"
      :starcolor='layer.starcolor'
      :backgroundcolors="layer.backgroundcolors"
      :rectangularType='layer.rectangularType'
      :scaleStars='layer.scaleStars'
      :scaleConstellations='layer.scaleConstellations'
      :scaleGrid='layer.scaleGrid'
      @ChangeApplySky='ChangeApplySky'
    />
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'image-star-map-field',
  components: {},
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    shapeDefauld(){
      if(this.layer.typeSkyStar == "stereo"){
        return this.layer.shapes[0]['file']['key']
      }else {
        return 'c139d4b0-8e04-11ec-8a9d-267b280bfd39__polar_png.png'
      }
    },
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    }

  },
  methods: {
    ChangeApplySky(data){
      this.$emit('ChangeApplySky', data)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Form/ImageStarMapField.vue